var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-section-marker",class:{ 'always-show': _vm.alwaysShow }},[_c('div',{staticClass:"inner-border"}),_c('p',{on:{"click":_vm.addFormSection}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")]),_vm._v(" "+_vm._s(_vm._f("translate")('forms.addSectionMarker'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }